<template>
  <div class="pc-search-table">
    <el-form class="pc-search-main-form" :model="dataArgs" :inline="true">
      <div class="line-one">
        <el-form-item label="城市名称" class="long-select">
          <el-input
            v-model="dataArgs.name"
            placeholder="请输入城市名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="标签" class="short-select">
          <el-cascader
            :options="options"
            v-model="dataArgs.keywords"
            clearable
            placeholder="选择标签"
          ></el-cascader>
        </el-form-item>
      </div>

      <div class="line-two">
        <el-form-item label="大洲" class="short-select">
          <el-select
            v-model="dataArgs.continent"
            clearable
            placeholder="选择大洲"
            @change="getCountryDicList($event)"
          >
            <el-option
              v-for="(item, index) in continentList"
              :key="index"
              :value="item.name ? item.name : item.englishName"
              :label="item.name ? item.name : item.englishName"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="国家" class="short-select">
          <el-select
            v-model="dataArgs.country"
            clearable
            placeholder="选择国家"
            :disabled="dataArgs.continent == null"
            @change="getProvinceDicList()"
          >
            <el-option
              v-for="(item, index) in countryList"
              :key="index"
              :value="item.name ? item.name : item.englishName"
              :label="item.name ? item.name : item.englishName"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="省" class="short-select">
          <el-select
            v-model="dataArgs.province"
            clearable
            placeholder="选择省"
            :disabled="dataArgs.continent == null || dataArgs.country == null"
          >
            <el-option
              v-for="(item, index) in provinceList"
              :key="index"
              :label="item.name ? item.name : item.englishName"
              :value="item.name ? item.name : item.englishName"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <button class="pc-search-clickBtn" @click.prevent="search()">筛选</button>
    </el-form>
    <div class="pc-city-list-table" ref="list">
      <div class="pc-list-head">
        <div class="pc-list-head-handle">
          <div class="pc-list-head-btn">
            <button @click="deleteCity">删除</button>
            <span></span>
            <button @click="addCity">添加</button>
            <span></span>
            <button @click="exportCity">导出数据</button>
          </div>
          <p>{{ "共" + dataArgs.total + "条" }}</p>
        </div>
      </div>

      <el-table
        class="pc-list-table"
        :data="cityList"
        id="out-table"
        @sort-change="changeSort"
      >
        <el-table-column width="130" fixed="left">
          <template slot="header" slot-scope="header">
            <el-checkbox v-model="isSelectAll" @change="selectAll">{{
              "已选" + checked.length + "个"
            }}</el-checkbox>
          </template>
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.isSelect"
              @change="
                singleCheck(
                  scope.$index,
                  scope.row.isSelect,
                  scope.row.id,
                  scope.row
                )
              "
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          sortable="custom"
          width="130"
          fixed="left"
        >
          <template slot-scope="scope">
            {{ Number(scope.row.id) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="160"
          fixed="left"
        ></el-table-column>
        <el-table-column label="封面图" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.bgImage" class="eltable-img">
              <img :src="scope.row.bgImage" />
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="collectNums"
          label="收藏人数"
          sortable="custom"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="position"
          label="位置"
          width="150"
        ></el-table-column>
        <el-table-column prop="tags" label="标签" width="200"></el-table-column>

        <el-table-column
          label="数据更新时间"
          prop="updateTime"
          sortable="custom"
          width="200"
        >
          <template slot-scope="scope">
            <div>{{ $dtime(scope.row.updateTime).format("YYYY-MM-DD") }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="状态"
          width="140"
          prop="status"
          sortable="custom"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-color="#91CC75"
              @change="changeStatus(scope.row)"
              inactive-color="#C7C7C7"
              :class="{
                'switch-is-active': scope.row.status,
                'switch-is-not-active': !scope.row.status,
              }"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column width="120">
          <template slot-scope="scope">
            <button class="btnViewDetail" @click="viewDetail(scope.row)">
              查看详情
            </button>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        v-if="cityList.length > 0"
        class="pagination"
        :pagination="dataArgs"
        @goPage="goPage"
        @handleCurrentChange="goPage"
        @goLastPage="goPage"
        @goFirstPage="goPage"
      />
      <ExportTable
        :tableData="selectedItems"
        :exportFeild="exportFeild"
        ref="exportTable"
      />
      <DeleteHint
        :dialogVisible="deleteDialogVisible"
        @cancel="closeDelete"
        @delete="isDelete"
      />
    </div>
  </div>
</template>


<script>
import {
  getDictionaries,
  getTagTypes,
  getCities,
  deleteCities,
  updateCityStatus,
} from "./searchTable.gql";
import DeleteHint from "../../../template/DeleteHint.vue";
import ExportTable from "../../../template/exportTable.vue";
import Pagination from "../../../template/Pagination";

export default {
  data() {
    return {
      deleteDialogVisible: false,
      continentList: [],
      countryList: [],
      provinceList: [],
      typeTagArgs: {
        skip: 0,
        type: "CITY",
        order: "+createTime",
      },
      options: [],
      dataArgs: {
        name: null,
        province: null,
        continent: null,
        country: null,
        keywords: null,
        take: 10,
        skip: 0,
        order: "-updateTime",
        type: null,
        status: -1,
      },
      cityList: [],

      selectIndex: null,
      isCancelSingle: true,
      isSelectAll: false,
      selectCount: 0,
      checked: [],
      selectedItems: [],
      exportFeild: [
        { label: "ID", prop: "id" },
        { label: "名称", prop: "name" },
        { label: "英文名", prop: "englishName" },
        { label: "所属大洲", prop: "continent" },
        { label: "所属国家", prop: "country" },
        { label: "所属省份", prop: "province" },
        { label: "经度", prop: "lng" },
        { label: "纬度", prop: "lat" },
        { label: "adcode", prop: "adcode" },
        { label: "英文简介", prop: "englishIntro" },
        { label: "中文简介", prop: "intro" },
        { label: "城市形态", prop: "formImage" },
        { label: "封面图", prop: "bgImage" },
        { label: "浏览人数", prop: "nums" },
        { label: "收藏人数", prop: "collectNums" },
        { label: "标签", prop: "tags" },
        { label: "面积", prop: "area" },
        { label: "人口", prop: "population" },
        { label: "GDP", prop: "gdp" },
        { label: "图片", prop: "images" },
        { label: "历史地图", prop: "maps" },
        { label: "视频", prop: "videos" },
        { label: "数据更新时间", prop: "updateTime1" },
        { label: "数据录入时间", prop: "createTime1" },
        { label: "状态", prop: "status1" },
      ],
    };
  },
  components: { Pagination, ExportTable, DeleteHint },
  async mounted() {
    // 获取下拉列表项
    this.getTagTypes();
    this.getContinentDicList("map_position");
    // this.getCountryDicList();
    this.getCities();
  },
  methods: {
    changeSort(val) {
      if (val.order == "ascending") {
        this.dataArgs.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.dataArgs.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.dataArgs.order = "-updateTime";
      }
      this.dataArgs.skip = 0;
      this.getCities();
    },
    changeStatus(val) {
      let status = 0;
      if (val.status == true) {
        status = "1";
      } else {
        status = "0";
      }
      this.$global
        .GraphqlMutation(this, updateCityStatus, { status: status, id: val.id })
        .then((res) => {
          this.$global.success(this, "操作成功");
          // this.getCities(this.cityArgs);
        });
    },
    getContinentDicList(type) {
      this.$global
        .GraphqlQuery(this, getDictionaries, { type: type })
        .then((res) => {
          this.continentList = res.data;
        });
    },
    getCountryDicList(a) {
      console.dir(a);
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: ("map_position_" + this.dataArgs.continent)
            .replace(" ", "_")
            .toLowerCase(),
        })
        .then((res) => {
          this.countryList = res.data;
        });
    },
    getProvinceDicList() {

      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: (
            "map_position_" +
            this.dataArgs.continent +
            "_" +
            this.dataArgs.country
          )
            .replace(" ", "_")
            .toLowerCase(),
        })
        .then((res) => {
          this.provinceList = res.data;
        });
    },
    getTagTypes() {
      this.options = [];
      this.$global
        .GraphqlQuery(this, getTagTypes, this.typeTagArgs)
        .then((res) => {
          for (let i = 0; res.data.length > i; i++) {
            this.options.push(res.data[i]);
            this.options[i].value = this.options[i].name;
            this.options[i].label = this.options[i].name;
            if (res.data[i].tags.length > 0) {
              this.options[i].children = res.data[i].tags;
              for (let t = 0; res.data[i].children.length > t; t++) {
                this.options[i].children[t].label =
                  this.options[i].children[t].name;
                this.options[i].children[t].value =
                  this.options[i].children[t].name;
              }
            }
          }
        });
    },
    search() {
      if (this.dataArgs.keywords) {
        this.dataArgs.keywords = this.dataArgs.keywords[1];
      }
      this.dataArgs.skip = 0
      this.getCities();

      // this.keywordData.keywords=''
    },
    deleteCity() {
      this.deleteDialogVisible = true;
    },
    addCity() {
      let route = this.$router.resolve({
        path: "/admin/cityDetail",
        name: "cityDetail",
      });
      window.open(route.href, "_blank");
    },
    exportCity() {
      this.$refs.exportTable.exports();
    },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/cityDetail",
        query: { id: item.id },
        name: "cityDetail",
        params: item,
      });
      window.open(route.href, "_blank");
      //    window.open(href, '_blank')
    },
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.selectedItems = [];
        this.cityList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
          this.selectedItems.push(item);
        });
      } else {
        this.cityList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
          this.selectedItems = [];
          if (item.status == true) {
            item.status1 = "有效";
          } else {
            item.status1 = "失效";
          }
        });
      }
    },
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            this.selectedItems.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (row.status == true) {
          row.status1 = "有效";
        } else {
          row.status1 = "失效";
        }
        this.selectedItems.push(row);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    getCities() {
      this.$global.GraphqlQuery(this, getCities, this.dataArgs).then((res) => {
        this.checked = [];
        this.$set(this.dataArgs, 'total', res.total )
        for (let i = 0; res.data.length > i; i++) {
          res.data[i].isSelect = false;
          res.data[i].position =
            res.data[i].country + "," + res.data[i].continent;
          let tags = "";
          res.data[i].tags.forEach((item, index) => {
            if (
              index < 3 &&
              item.name != res.data[i].country &&
              item.name != res.data[i].continent &&
              item.name != res.data[i].province
            ) {
              if (res.data[i].cityGroup) {
                if (
                  item.name != res.data[i].cityGroup.name &&
                  item.name != res.data[i].cityGroup.englishName
                ) {
                  tags += item.name + ", ";
                }
              } else {
                tags += item.name + ", ";
              }
            }
          });
          res.data[i].tags = tags.substr(0, tags.length - 2);
          if (res.data[i].status == "1") {
            res.data[i].status = true;
          } else {
            res.data[i].status = false;
          }
          let videos = "";
          if (res.data[i].videos) {
            res.data[i].videos.forEach((item) => {
              videos += item.video + ",";
            });
            res.data[i].videos = videos.substr(0, videos.length - 2);
          }
          let images = "";
          if (res.data[i].images) {
            res.data[i].images.forEach((item) => {
              images += item.image + ",";
            });
            res.data[i].images = images.substr(0, images.length - 2);
          }
          let maps = "";
          if (res.data[i].maps) {
            res.data[i].maps.forEach((item) => {
              maps += item.image + ",";
            });
            res.data[i].maps = maps.substr(0, maps.length - 2);
          }
          if (res.data[i].basicData) {
            res.data[i].basicData.forEach((item) => {
              if (item.name == "Area") {
                res.data[i].area = item.value;
              }
              if (item.name == "Population") {
                res.data[i].population = item.value;
              }
              if (item.name == "GDP") {
                res.data[i].gdp = item.value;
              }
            });
          }
          res.data[i].updateTime1 = this.$dtime(res.data[i].updateTime).format("YYYY-MM-DD HH:MM:SS")
          res.data[i].createTime1 = this.$dtime(res.data[i].createTime).format("YYYY-MM-DD HH:MM:SS")
          // res.data[i].status = res.data[i].status == "1" ? true : false;
        }
        this.cityList = res.data;
        // console.log(this.regionList);
        // this.tabName = '1'
        // this.removeTag();
      });
    },
    goPage(data) {
      this.dataArgs.skip = (data - 1) * 10;
      this.getCities();
      window.scrollTo(0, this.$refs.list.offsetTop + 210);
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    isDelete() {
      let data = { ids: this.checked };
      this.$global
        .GraphqlMutation(this, deleteCities, { data: data })
        .then((res) => {
          this.getCities();
          this.deleteDialogVisible = false;
        });
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-search-table {
  //   min-width: 1670px;

  box-shadow: $boxshadow;
  padding: 30px 35px 10px;
  margin-top: 40px;
  .pc-search-main-form {
    position: relative;
    .line-one,
    .line-two {
      width: 90%;
    }

    /deep/ .el-input__icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/ .el-form-item__label {
      font-family: $chinese;
      font-size: 16px;
      font-weight: bold;
      color: $mainTitle;
      width: 100px;
      margin-right: 40px;
    }

    /deep/ .long-select {
      width: 853px;
      .el-form-item__content {
        width: 710px;
        .el-input__inner {
          width: 100%;
        }
      }
    }
    /deep/ .short-select .el-input__inner {
      width: 280px;
    }
    .pc-search-clickBtn {
      position: absolute;
      right: 0px;
      bottom: 20px;
      width: 90px;
      height: 40px;
      background: $blueBtn;
      border-radius: 4px;
      outline: none;
      border: none;
      font-family: $chinese;
      font-size: 14px;
      color: white;
      cursor: pointer;
    }
  }
  .pc-city-list-table {
    margin-top: 40px;
    .pc-list-head {
      margin-top: 40px;
      border-top: 1px solid #c0c0c0;
      padding-top: 35px;
      margin-bottom: 35px;
      letter-spacing: 1px;
      font-family: $chinese;
      font-size: 14px;
      color: $mainTitle;
      .pc-list-head-handle {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        .pc-list-head-btn {
          display: flex;
          border: 1px solid $schoolTagBorder;
          margin-right: 30px;
          border-radius: 4px;
          button,
          p {
            cursor: pointer;
            font-family: $chinese;
            font-size: 14px;
            color: $mainTitle;
            letter-spacing: 1px;
          }
          button {
            width: 100px;
            background: none;
            outline: none;
            padding: 10px 0px;
            box-sizing: content-box;
            border: none;
          }
          span {
            height: 16px;
            border: 1px solid $schoolTagBorder;
            align-self: center;
          }
          button:hover {
            background: $blueBtn;
            color: white;
          }
          p {
            margin-left: 32px;
          }
        }
      }
    }

    .pc-list-table {
      overflow: visible !important;
      .eltable-img {
        img {
          height: 50px;
          // width:100px;
          object-fit: cover;
        }
      }
      .btnViewDetail {
        width: 90px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid $timeBtn;
        outline: none;
        background: none;
        font-family: $chinese;
        font-size: 12px;
        color: $timeBtn;
        cursor: pointer;
      }
      .btnViewDetail:hover {
        background: $blueBtn;
        color: white;
      }
      /deep/ .el-table__body-wrapper {
        min-height: 500px;
      }
      /deep/ .cell {
        text-align: center !important;
        font-family: $chinese !important;
        font-size: 14px !important;
        color: $thirdTitle;
      }
      /deep/ .el-table__row {
        .cell {
          color: $mainTitle !important;
        }
      }
      /deep/ .is-leaf {
        background: $base-color !important;
        font-weight: normal !important;
      }
      /deep/ .el-switch__core {
        width: 54px !important;
        height: 20px !important;
        display: flex;
        align-items: center;
      }
      .switch-is-active {
        /deep/ .el-switch__core {
          &::before {
            content: "有效";
            font-size: 8px;
            color: white;
            padding-left: 6px;
          }
        }
      }
      .switch-is-not-active {
        /deep/ .el-switch__core {
          &::before {
            content: "无效";
            font-size: 8px;
            color: white;
            padding-left: 22px;
          }
        }
      }
    }
    .pagination {
      margin-top: 45px;
    }
    /deep/ .pc-pagin {
      justify-content: flex-end !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/map/cityList/SearchTable.vue